import type { ITaskRepository } from "@src/domain/pascos/repository/task_repository";
import { TaskStatus } from "@src/domain/pascos/value_objects/task_status";
import type { TaskDTO, UpdateTaskStatusDTO } from "../dto";
import { TaskDtoMapper } from "../mappers/task-dto.mapper";

/**
 * Use Case: Update Task Status
 * Updates the status of a task (useful for rescheduling failed tasks)
 */
export class UpdateTaskStatusUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    /**
     * Execute the use case
     * @param taskId - The unique identifier of the task
     * @param updateData - The status update data
     * @returns Promise<TaskDTO> - The updated task data
     */
    async execute(taskId: string, updateData: UpdateTaskStatusDTO): Promise<TaskDTO> {
        const status = updateData.status as TaskStatus;
        const updatedTask = await this.taskRepository.updateTaskStatus(taskId, status);
        return TaskDtoMapper.toDTO(updatedTask);
    }
}
